export default "/images/vendor/flag-icon-css/flags/4x3/pt.svg?b89a5b80ca1a71c3b96a85fe858b62da";